import { getPurchaseInfo } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback, useEffect, useRef } from "react";

const useTrackPurchase = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");

  const isEnabledRef = useRef(false);

  useEffect(() => {
    isEnabledRef.current = isWebEngageEnabled;
  }, [isWebEngageEnabled]);

  const trackPurchase = useCallback((orderData) => {
    if (!isEnabledRef.current) {
      console.warn("WebEngage feature is disabled");
      return;
    }
    if (typeof window !== "undefined" && window.webengage) {
      if (orderData) {
        window.webengage.track("purchase", getPurchaseInfo(orderData));
      }
    } else {
      console.error("WebEngage is not defined");
    }
  }, []);

  return { trackPurchase };
};

export default useTrackPurchase;
